import { PayoutDetailsOverviewModule } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/PayoutDetailsOverview';
import { TransactionsListModule } from '@/components/modules/Payouts/PayoutDetails/TransactionsList/TransactionsList';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_PAYOUT: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.PAYOUT,
  schemesByRoles: [
    {
      roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.MERCHANT_GROUP, APP_ROLES.MERCHANT, APP_ROLES.PARTNER],
      titleTextId: 'PAYOUT',
      widgets: [
        { id: WIDGETS.PAYOUT_PAGE_TITLE, roles: [...ALL_CORE_APP_ROLES], props: {}, notShownInRightMenu: true },
      ],
    },
  ],
  sections: [
    {
      textId: '',
      module: (
        <PayoutDetailsOverviewModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
            ],
          }}
        />
      ),
    },
    {
      textId: '',
      module: (
        <TransactionsListModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
            ],
          }}
        />
      ),
    },
  ],
};
